import React, { useEffect, useState } from 'react'
import { useClaimant } from '../context/col'
import useAsync from '../hooks/useAsync'
import {
  CaseReportParamsType,
  CaseReportRespType,
  CostRespType,
  transformCaseReportRespToCaseReportParams,
} from '../models'
import useGetData from '../hooks/useGetData'
import TreatmentExpensesForm from '../components/forms/TreatmentExpensesForm'
import { putCaseReport } from '../services/case-report/put'
import { useTreatmentExpensesProvider } from '../context/TreatmentExpensesContext'

export type TreatmentExpensesPageProps = {
  transitions: TreatmentExpensesPageTransitions
}

export type TreatmentExpensesPageTransitions = {
  goBack: () => void
  goToNextPage: () => void
}

const TreatmentExpenses = (props: TreatmentExpensesPageProps) => {
  const { state, dispatch } = useClaimant()
  const { treatmentExpensesType, changeTreatmentExpensesType } =
    useTreatmentExpensesProvider()
  const [ifEqual, setIfEqual] = useState<boolean>(true)
  const { fetch: fetchData, pending: loading } = useGetData({})

  React.useEffect(() => {
    fetchData()
  }, [treatmentExpensesType])

  const handleTreatmentExpensesDataPageSubmitted = (
    treatmentExpensesDataParams: CostRespType[]
  ) => {
    const {
      loadedCaseReportResp,
    }: { loadedCaseReportResp: CaseReportRespType | undefined } = state

    const treatmentExpenses = () => {
      if (treatmentExpensesType === 'OP') {
        return {
          ...state.loadedCaseReportResp?.caseME?.treatmentExpenses,
          OP: {
            treatmentType: 'OP',
            costs: treatmentExpensesDataParams,
          },
        }
      }
      if (treatmentExpensesType === 'IP') {
        return {
          ...state.loadedCaseReportResp?.caseME?.treatmentExpenses,
          IP: {
            treatmentType: 'IP',
            costs: treatmentExpensesDataParams,
          },
        }
      }
      if (treatmentExpensesType === 'OTH') {
        return {
          ...state.loadedCaseReportResp?.caseME?.treatmentExpenses,
          OTH: {
            treatmentType: 'OTH',
            costs: treatmentExpensesDataParams,
          },
        }
      }
    }

    const newCaseReportDataResp = {
      ...loadedCaseReportResp,
      caseME: {
        ...state.loadedCaseReportResp?.caseME,
        treatmentExpenses: treatmentExpenses(),
      },
    } as CaseReportRespType

    // 2. Pripravena finalni data, ktera se budou odesilat
    const caseReportParamsForUpdate: CaseReportParamsType =
      transformCaseReportRespToCaseReportParams(newCaseReportDataResp)

    // 3. aktualizujeme state -- do currentCaseReportData nastavime newCaseReportDataResp
    //    a zmenime 'stranku'
    dispatch({
      type: 'update_caseReportParams',
      payload: { data: newCaseReportDataResp, page: 3 },
    })

    doPutCaseReport({
      caseReportId: state.caseReportId,
      caseReportParams: caseReportParamsForUpdate,
    })
  }

  const { fetch: doPutCaseReport, pending } = useAsync({
    promiseFn: (params: any) => putCaseReport(params),
    onData: () => {
      dispatch({ type: 'control_change', payload: { controlChange: true } })
      const treatmentTypes = state.loadedCaseReportResp?.caseME?.treatmentTypes
      const treatmentTypeIndex = treatmentTypes?.findIndex(
        (treatmentType) => treatmentType === treatmentExpensesType
      )
      if (
        /* there is next treatment type?*/
        treatmentTypes?.length &&
        (treatmentTypeIndex || treatmentTypeIndex === 0) &&
        treatmentTypeIndex < treatmentTypes?.length - 1
      ) {
        changeTreatmentExpensesType(treatmentTypes[treatmentTypeIndex + 1])
        return
      } else {
        // there is no next treatment type
        props.transitions.goToNextPage()
      }
    },
    onError: (error) => {
      dispatch({ type: 'error', payload: { error: error.message } })
    },
  })

  useEffect(() => {
    dispatch({ type: 'control_change', payload: { controlChange: ifEqual } })
  }, [ifEqual])

  React.useEffect(() => {
    fetchData({ id: state.caseReportId })
  }, [])

  const handleCostPageBack = () => {
    const treatmentTypes = state.loadedCaseReportResp?.caseME?.treatmentTypes
    const treatmentTypeIndex = treatmentTypes?.findIndex(
      (treatmentType) => treatmentType === treatmentExpensesType
    )
    if (
      /* there is a previous treatment type?*/
      treatmentTypes?.length &&
      (treatmentTypeIndex || treatmentTypeIndex === 0) &&
      treatmentTypeIndex > 0
    ) {
      changeTreatmentExpensesType(treatmentTypes[treatmentTypeIndex - 1])
      return
    } else {
      props.transitions.goBack()
    }
  }

  return (
    <TreatmentExpensesForm
      caseReportId={state.caseReportId!}
      caseME={state.loadedCaseReportResp?.caseME}
      treatmentExpensesType={treatmentExpensesType}
      onPageContinue={handleTreatmentExpensesDataPageSubmitted}
      onPageBack={handleCostPageBack}
      errorMessage={state.error}
      isContinueInProgress={pending}
      isDataLoading={loading}
      setIfEqual={setIfEqual}
    />
  )
}

export default TreatmentExpenses
